module.exports = __webpack_public_path__ + "img/MY.a5dfe4a3.png";